import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import TrademarkRegistration from "./pages/TrademarkRegistration";
import CopyrightRegistration from "./pages/CopyrightRegistration";
import CompanyFormation from "./pages/CompanyFormation";
import TrademarkSearch from "./pages/TrademarkSearch";
import AmazonBrandRegistry from "./pages/AmazonBrandRegistry";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

// Trademark Services
import TrademarkOwnershipTransfers from "./pages/services/TrademarkOwnershipTransfers";
import StatementsOfUse from "./pages/services/StatementsOfUse";
import TrademarkOfficeActions from "./pages/services/TrademarkOfficeActions";
import TrademarkInfringementMonitoring from "./pages/services/TrademarkInfringementMonitoring";
import TrademarkMonitoring from "./pages/services/TrademarkMonitoring";
import TTABPetition from "./pages/services/TTABPetition";

// Company Formation Services
import LLCFormation from "./pages/services/LLCFormation";
import CCorporation from "./pages/services/CCorporation";
import SCorporation from "./pages/services/SCorporation";
import NonProfitFormation from "./pages/services/NonProfitFormation";

// Copyright Services
import CopyrightEnforcement from "./pages/services/CopyrightEnforcement";
import CopyrightTransfers from "./pages/services/CopyrightTransfers";
import CopyrightLegal from "./pages/services/CopyrightLegal";
import CopyrightPortfolio from "./pages/services/CopyrightPortfolio";
import DMCACompliance from "./pages/services/DMCACompliance";

// Patent Services
import PatentSearch from "./pages/services/PatentSearch";
import PatentOfficeActions from "./pages/services/PatentOfficeActions";
import PatentApplication from "./pages/services/PatentApplication";
import PatentLegal from "./pages/services/PatentLegal";

// Legal Services
import BusinessImmigration from "./pages/services/BusinessImmigration";
import DueDiligence from "./pages/services/DueDiligence";
import ITCommercialLaw from "./pages/services/ITCommercialLaw";
import PartnershipsLLPs from "./pages/services/PartnershipsLLPs";
import DataProtection from "./pages/services/DataProtection";

// Corporate Services
import Bookkeeping from "./pages/services/Bookkeeping";
import BusinessFormation from "./pages/services/BusinessFormation";
import GoodStandingCertificate from "./pages/services/GoodStandingCertificate";
import CompanyDissolution from "./pages/services/CompanyDissolution";
import CompanyNameChange from "./pages/services/CompanyNameChange";
import CompanyRenewal from "./pages/services/CompanyRenewal";
import IssueShares from "./pages/services/IssueShares";
import NomineeServices from "./pages/services/NomineeServices";
import TaxAdvisory from "./pages/services/TaxAdvisory";
import TransferShares from "./pages/services/TransferShares";
import CFOServices from "./pages/services/CFOServices";

function AppContent() {
  const location = useLocation();
  const isLandingPage = location.pathname === '/lp';
  const isApplicationPage = location.pathname.startsWith('/application');

  return (
    <>
      <ScrollToTop />
      {!isLandingPage && !isApplicationPage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/lp" element={<LandingPage />} />
        
        {/* Trademark Services */}
        <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
        <Route path="/services/trademark-search" element={<TrademarkSearch />} />
        <Route path="/services/trademark-ownership-transfers" element={<TrademarkOwnershipTransfers />} />
        <Route path="/services/statements-of-use" element={<StatementsOfUse />} />
        <Route path="/services/trademark-office-actions" element={<TrademarkOfficeActions />} />
        <Route path="/services/trademark-infringement-monitoring" element={<TrademarkInfringementMonitoring />} />
        <Route path="/services/trademark-monitoring" element={<TrademarkMonitoring />} />
        <Route path="/services/file-ttab-petition" element={<TTABPetition />} />
        <Route path="/services/ttab-petition" element={<TTABPetition />} />
        
        {/* Company Formation Services */}
        <Route path="/services/company-formation" element={<CompanyFormation />} />
        <Route path="/services/llc-formation" element={<LLCFormation />} />
        <Route path="/services/c-corporation" element={<CCorporation />} />
        <Route path="/services/s-corporation" element={<SCorporation />} />
        <Route path="/services/non-profit-formation" element={<NonProfitFormation />} />
        
        {/* Copyright Services */}
        <Route path="/services/copyright-registration" element={<CopyrightRegistration />} />
        <Route path="/services/copyright-enforcement" element={<CopyrightEnforcement />} />
        <Route path="/services/copyright-transfers" element={<CopyrightTransfers />} />
        <Route path="/services/copyright-legal" element={<CopyrightLegal />} />
        <Route path="/services/copyright-portfolio" element={<CopyrightPortfolio />} />
        <Route path="/services/dmca-compliance" element={<DMCACompliance />} />
        
        {/* Patent Services */}
        <Route path="/services/patent-search" element={<PatentSearch />} />
        <Route path="/services/patent-office-actions" element={<PatentOfficeActions />} />
        <Route path="/services/patent-application" element={<PatentApplication />} />
        <Route path="/services/patent-legal" element={<PatentLegal />} />
        
        {/* Legal Services */}
        <Route path="/services/business-immigration" element={<BusinessImmigration />} />
        <Route path="/services/due-diligence" element={<DueDiligence />} />
        <Route path="/services/it-commercial-law" element={<ITCommercialLaw />} />
        <Route path="/services/partnerships-llps" element={<PartnershipsLLPs />} />
        <Route path="/services/data-protection" element={<DataProtection />} />
        
        {/* Corporate Services */}
        <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry />} />
        <Route path="/services/bookkeeping" element={<Bookkeeping />} />
        <Route path="/services/business-formation" element={<BusinessFormation />} />
        <Route path="/services/good-standing-certificate" element={<GoodStandingCertificate />} />
        <Route path="/services/company-dissolution" element={<CompanyDissolution />} />
        <Route path="/services/company-name-change" element={<CompanyNameChange />} />
        <Route path="/services/company-renewal" element={<CompanyRenewal />} />
        <Route path="/services/issue-shares" element={<IssueShares />} />
        <Route path="/services/nominee-services" element={<NomineeServices />} />
        <Route path="/services/tax-advisory" element={<TaxAdvisory />} />
        <Route path="/services/transfer-shares" element={<TransferShares />} />
        <Route path="/services/cfo-services" element={<CFOServices />} />
      </Routes>
      {!isLandingPage && !isApplicationPage && <Footer />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
